import styled from '@emotion/styled'
import theme from '../../../styles/theme'
import {
  InfoSmall500Style,
  InfoExtraSmall500Style,
} from '../../../styles/Text.styles'

// Interfaces for styled component props
interface TagColorProps {
  color?: string
  bg?: string
}

interface FilledTagProps {
  color?: string
}

/*
 * Base tag component that provides common styling for all tags
 */
export const BaseTag = styled.span`
  align-items: center;
  gap: 4px;
  padding: 0.3rem 0.5rem;
  border-radius: 4rem;
  display: inline-block;
  white-space: nowrap;
  //make text never wrap
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: row;
`

/*
 * Active tag component with default green styling
 */
export const StyledSuccessTag = styled(BaseTag)<TagColorProps>`
  color: ${(props) => props.color || '#12b76a'};
  background-color: ${(props) => props.bg || '#ecfdf3'};
  text-transform: capitalize;
`

/*
 * Inactive tag component with default orange styling
 */
export const StyledWarningTag = styled(BaseTag)<TagColorProps>`
  color: ${(props) => props.color || '#f79009'};
  background-color: ${(props) => props.bg || '#fffaeb'};
  text-transform: capitalize;
`

export const StyledDangerTag = styled(BaseTag)<TagColorProps>`
  color: ${(props) => props.color || theme.colors.suplementRed};
  background-color: ${(props) => props.bg || '#ffebeb'};
  text-transform: capitalize;
`

/*
 * Info tag component with default blue styling
 */
export const StyledInfoTag = styled(BaseTag)<TagColorProps>`
  color: ${(props) => props.color || '#3b82f6'};
  background-color: ${(props) => props.bg || '#eff6ff'};
  text-transform: capitalize;
`

/*
 * Normal tag component with default purple styling
 */
export const StyledNormalTag = styled(BaseTag)`
  color: ${theme.colors.secondHighlight};
  background-color: ${theme.colors.second};
  font-size: 0.8rem;
  font-weight: 600;
`

/*
 * Filled active tag component with solid green background
 */
export const StyledFilledActiveTag = styled(BaseTag)<FilledTagProps>`
  color: white;
  background-color: ${(props) => props.color || '#12b76a'};
  text-transform: capitalize;
`

/*
 * Filled inactive tag component with solid orange background
 */
export const StyledFilledInactiveTag = styled(BaseTag)<FilledTagProps>`
  color: white;
  background-color: ${(props) => props.color || '#f79009'};
  text-transform: capitalize;
`

/*
 * Small tag component for minimal information display
 */
export const SmallNormalTag = styled.span`
  ${InfoSmall500Style};
  background-color: ${theme.colors.secondLight};
  color: ${theme.colors.secondDarkest} !important  ;
  padding: 0.4rem 0.5rem !important  ;
  border-radius: 4rem;
  display: inline-block;
  margin-right: 0.5rem;
`

export const VerySmallNormalTag = styled.span`
  ${InfoExtraSmall500Style};
  background-color: ${theme.colors.second} !important  ;
  color: ${theme.colors.secondDarkest} !important  ;
  padding: 0.4rem 0.4rem !important  ;
  border-radius: 0.8rem;
  display: inline-block;
  margin-right: 0.5rem;
`

export const VerySmallErrorTag = styled.span`
  ${InfoExtraSmall500Style};
  background-color: #e27f7f !important  ;
  color: ${theme.colors.surface} !important  ;
  padding: 0.4rem 0.4rem !important  ;
  border-radius: 0.8rem;
  display: inline-block;
  margin-right: 0.5rem;
`
